import Vue from 'vue'
import { mapState } from 'vuex'

import { FindItem } from '@/api/data-logger'
// import { SendCommand, Handler } from '@/api/rt'
import { IPanel } from '@/types/view'

import { DataLog, Item } from '../../types/data-log'
import { SelectOption } from './types'

export default Vue.extend({
  props: {
    value: Object,
  },
  data() {
    return {
      // eslint-disable-next-line
      model: { query: [] as any[] } as IPanel,
      dataLoggerItems: [] as Item[],
      dataLoggerId: -1,
    }
  },
  computed: {
    ...mapState('tag', { tags: 'items' }),
    ...mapState('datalog', { dataLoggers: 'items' }),
    optsDataLogger(): SelectOption[] {
      return this.$store.state.datalog.items.map((d: DataLog) => {
        return { value: d.id, text: d.name }
      })
    },
  },
  methods: {
    parseInput() {
      this.model = {
        ...this.value,
        // query: this.value.query.map((q: string) => JSON.parse(q)),
      }
    },
    // eslint-disable-next-line
    parseModel(): IPanel {
      return {
        ...this.model,
        // query: this.model.query.map((q) => JSON.stringify(q)),
      }
    },

    // async fetchData() {
    //   const res = await SendCommand({
    //     handler: Handler.datalog,
    //     q: this.model.query,
    //   })

    //   return res
    // },

    async findItem(datalogId: number) {
      this.dataLoggerItems = await FindItem({ datalogId } as Item)
    },
  },
  watch: {
    value: {
      deep: true,
      // eslint-disable-next-line
      handler: function(val: any) {
        const parsedModel = this.parseModel()
        if (JSON.stringify(val) != JSON.stringify(parsedModel)) {
          // this.model = this.value
          this.parseInput()
        }
      },
    },
    model: {
      deep: true,
      handler: function(val) {
        if (JSON.stringify(val) != JSON.stringify(this.value)) {
          this.$emit('input', this.parseModel())
        }
      },
    },

    dataLoggerId: async function(val: number) {
      await this.findItem(val)
    },
  },

  created() {
    this.parseInput()
  },
})
